module.exports = __webpack_public_path__ + "img/sceneIcon1-7.c460eba9.png";